<template lang="pug">
  #pFooter.bgColor-footer.l-padding-top-3em.l-padding-bottom-1em
    .c-footer.flexD.flexDirectionRow
      .c-footer__logo
        img(:src="img.logo" alt="" @click="jumoToScroll(0)")
      .c-footer__sitemap.flexD.justifySpaceBetween.m-minWidthAuto
        .c-footer__sitemap--blocks.flexD.alignItemsCenter(v-for="(item,index) in text.sitemap" :key="index")
          p.c-footer__sitemap--block.cursorPointer(@click="jumoToScroll(item.key)") {{item.text}}
      .c-footer__contact.flexD.justifyCenter.alignItemsCenter
        .flexD.flexDirectionColumn
          p {{ text.address }}
          p {{ text.email }}
        img(:src="img.qr" )
    .c-footer__copyright.l-margin-top-3em.textAlignCenter
      | {{ text.copyright }}
      a(href="https://beian.miit.gov.cn" target="_blank") {{ text.copyrightA }}
</template>

<script>
  export default {
    name: 'pFooter',
    data(){
      return{
        text:{
          email: this.$t('footer.email'),
          address: this.$t('footer.address'),
          copyright: this.$t('footer.copyright'),
          copyrightA: "",
          sitemap:[
            {text: this.$t('menu.business'), key: 1},
            {text: this.$t('menu.about_us'), key: 2},
            {text: this.$t('menu.team_work'), key: 3},
            {text: this.$t('menu.contact_us'), key: 4},
          ],
        },
        img:{
          logo: require('@/assets/img/logo_white.png'),
          qr: require('@/assets/img/imv_qr.jpg')
        },
      }
    },
    computed: {},
    methods:{
      jumoToScroll(key){
        this.$parent.jumpToScroll(key)
      }
    },
    created(){
      let host = document.domain
      if(host == 'www.systec-pbx.net' || host == 'systec-pbx.net') {
        this.text.copyrightA = this.$t('footer.copyright_link1')
      } else if (host == 'www.senicare.cn' ||host == 'senicare.cn') {
        this.text.copyrightA = this.$t('footer.copyright_link2')
      } else if (host == 'www.imv-ltd.com') {
        this.text.copyrightA = this.$t('footer.copyright_link3')
      } else {
        this.text.copyrightA = this.$t('footer.copyright_link3')
      }
    }
  }
</script>
